module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "card"
  }, [_c('div', {
    staticClass: "card-header",
    attrs: {
      "data-background-color": "magenta-dark"
    }
  }, [_c('h4', [_vm._v("Ultima posición reportada al momento de la búsqueda")]), _vm._v(" "), _c('div', {
    staticClass: "actions-container"
  }, [_c('button', {
    staticClass: "btn-link",
    on: {
      "click": _vm.refresh
    }
  }, [_vm._v("Refrescar")]), _vm._v(" "), _vm._t("default")], 2)]), _vm._v(" "), _c('div', {
    staticClass: "card-content"
  }, [_c('table', [_c('tbody', [_c('tr', [_c('td', {
    staticClass: "title"
  }, [_vm._v("Tiempo")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(("Hace " + _vm.timeDifference)))])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "title"
  }, [_vm._v("Dirección")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.address))])])])])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-406852ac!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/UIComponents/LastPositionTable.vue
// module id = 246
// module chunks = 3